import type { RootState } from '../../../../configuration/setup/store';

export const getUserSidebar = (state: RootState) => state.userSidebar;
export const getSelectedUser = (state: RootState) => getUserSidebar(state).selectedUser;
export const getPersistedUser = (state: RootState) =>
    getUserSidebar(state).persistedUser ?? {
        email: state.app.selectedUser?.email ?? '',
        phoneNumber: state.app.selectedUser?.phone_number ?? undefined,
        firstName: state.app.selectedUser?.first_name ?? '',
        lastName: state.app.selectedUser?.last_name ?? '',
        groups: state.app.selectedUser?.group_ids,
    };
export const getFirstNameInSidebar = (state: RootState) => getSelectedUser(state).firstName;
export const getLastNameInSidebar = (state: RootState) => getSelectedUser(state).lastName;
export const getEmailInSidebar = (state: RootState) => getSelectedUser(state).email;
export const getPhoneNumberInSidebar = (state: RootState) => getSelectedUser(state).phoneNumber;
export const getUserGroupsInSidebar = (state: RootState) => getSelectedUser(state).groups;
export const getPersistedEmailInSidebar = (state: RootState) => getPersistedUser(state).email;
export const getPersistedPhoneNumberInSidebar = (state: RootState) => getPersistedUser(state).phoneNumber;
export const getPersistedFirstNameInSidebar = (state: RootState) => getPersistedUser(state).firstName;
export const getPersistedLastNameInSidebar = (state: RootState) => getPersistedUser(state).lastName;
export const getPersistedGroupIdsInSidebar = (state: RootState) => getPersistedUser(state).groups;

export const getShowConfirmation = (state: RootState) => getUserSidebar(state).showConfirmation;
export const getShowDeleteConfirmation = (state: RootState) => getUserSidebar(state).showDeleteConfirmation;

export const namesInSidebarNotEmpty = (state: RootState) =>
    getFirstNameInSidebar(state).length !== 0 && getLastNameInSidebar(state).length !== 0;

export const groupsInSidebarNotEmpty = (state: RootState) => {
    const groups = getUserGroupsInSidebar(state);
    return groups ? groups.length > 0 : true; // groups is initially undefined, so we return true to not block the user from saving changes to user name
};
